import {
  CalendarClockIcon,
  InboxIcon,
  PersonIcon,
  TargetIcon,
  TrendingUpIcon,
  TrophyLineIcon,
} from 'assets/icons';
import useText from 'hooks/useText';
import ResultTiles from './ResultTiles';
import StatsCard, { CardAside } from './StatsCard';
import { countDelta, euros, percent, pointsDelta, rate } from './statsFormat';
import { goalLabel } from './statsGoals';

const showUp = (total) => rate(total.rdvDone, total.rdvDone + total.rdvNoShow);
const closing = (total) => rate(total.sales, total.rdvDone);

/**
 * « Résultats » of a period: the appointments held, the requests that came
 * in, the sales and their revenue, the show-up and the closing, each against
 * the period before (`previous`). Revenue not invoiced yet is an estimate
 * from the timesheets, which the tile says.
 */
const ResultsCard = ({ current, previous, aside, goals = {} }) => {
  const { text, plural } = useText('stats');
  const deltaOf = (key, unit) =>
    previous && countDelta(current[key], previous[key], unit);
  const tiles = [
    {
      key: 'rdvDone',
      icon: CalendarClockIcon,
      value: String(current.rdvDone),
      delta: deltaOf('rdvDone'),
      label: plural('resultHeld', current.rdvDone),
      goal: goals.rdvDone,
      formatGoal: goalLabel,
    },
    {
      key: 'inbound',
      icon: InboxIcon,
      value: String(current.inbound),
      delta: deltaOf('inbound'),
      label: plural('resultInbound', current.inbound),
    },
    {
      key: 'sales',
      icon: TrophyLineIcon,
      value: String(current.sales),
      delta: deltaOf('sales'),
      label: plural('resultSales', current.sales),
      goal: goals.sales,
      formatGoal: goalLabel,
    },
    {
      key: 'revenue',
      icon: TrendingUpIcon,
      value: euros(current.revenue),
      delta: deltaOf('revenue', ' €'),
      label: text('resultRevenue'),
      note:
        current.revenueEstimated > 0
          ? text('resultRevenueEstimated', {
              amount: euros(current.revenueEstimated),
            })
          : null,
      noteHint: text('resultRevenueEstimatedHint'),
      goal: goals.revenue,
      formatGoal: (value) => euros(Math.round(value)),
    },
    {
      key: 'showUp',
      icon: PersonIcon,
      value: percent(showUp(current)),
      delta: previous && pointsDelta(showUp(current), showUp(previous)),
      label: text('resultShowUp'),
    },
    {
      key: 'closing',
      icon: TargetIcon,
      value: percent(closing(current)),
      delta: previous && pointsDelta(closing(current), closing(previous)),
      label: text('resultClosing'),
    },
  ];
  return (
    <StatsCard
      title={text('results')}
      aside={aside && <CardAside>{aside}</CardAside>}
    >
      <ResultTiles
        tiles={tiles}
        goalLabel={(value) => text('goalLabel', { value })}
      />
    </StatsCard>
  );
};

export default ResultsCard;
